import script from './panel-time-range.vue_vue_type_script_lang.mjs';
export { default } from './panel-time-range.vue_vue_type_script_lang.mjs';
import { render } from './panel-time-range.vue_vue_type_template_id_57d94b44_lang.mjs';

script.render = render;
script.__file = "packages/components/time-picker/src/time-picker-com/panel-time-range.vue";
//# sourceMappingURL=panel-time-range.mjs.map
